import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import type { ParagraphConfidenceInfo } from './citation-utils';

export const confidenceKey = new PluginKey<DecorationSet>('confidence');

export const createConfidencePlugin = () =>
  new Plugin<DecorationSet>({
    key: confidenceKey,
    state: {
      init() {
        return DecorationSet.empty;
      },
      apply(tr, set) {
        set = set.map(tr.mapping, tr.doc);

        const meta = tr.getMeta(confidenceKey);
        if (meta === undefined) {
          return set;
        }

        const payload = meta as ParagraphConfidenceInfo[];
        const decorations: Decoration[] = [];

        payload.forEach(({ position, confidence }) => {
          const node = tr.doc.nodeAt(position);
          if (!node) {
            return;
          }
          const nodeSize = node.nodeSize;
          if (nodeSize <= 0) {
            return;
          }

          if (confidence === 'grounded') {
            decorations.push(
              Decoration.node(position, position + nodeSize, {
                class: 'confidence-grounded',
              }),
            );
            return;
          }

          if (confidence === 'weak') {
            decorations.push(
              Decoration.node(position, position + nodeSize, {
                class: 'confidence-weak',
              }),
            );
          }
        });

        return DecorationSet.create(tr.doc, decorations);
      },
    },
    props: {
      decorations(state) {
        return confidenceKey.getState(state) || DecorationSet.empty;
      },
    },
  });
